import { breakpoints } from './constants';
class ResizeHandler {
  static DEBOUNCE_DELAY = 300;
  constructor() {
    this.breakpoints = breakpoints;
    this.isInitialized = false;
    this.handleResize = this.handleResize.bind(this);
    this.debouncedResize = this.debounce(this.handleResize, ResizeHandler.DEBOUNCE_DELAY);
  }

  /**
   * Creates a debounced version of a function
   * @param {Function} func - Function to debounce
   * @param {number} delay - Delay in milliseconds
   * @returns {Function} Debounced function
   */
  debounce(func, delay) {
    var _this = this;
    let timeoutId;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(_this, args), delay);
    };
  }

  /**
   * Handles the resize event
   * @param {Event} [event] - The resize event
   */
  handleResize() {
    const windowWidth = window.innerWidth;
    const breakpoint = this.getCurrentBreakpoint(windowWidth);
    const resizeEvent = new CustomEvent('windowResize', {
      detail: {
        windowWidth,
        breakpoint
      }
    });
    window.dispatchEvent(resizeEvent);
    this.isInitialized = true;
  }

  /**
   * Gets the current breakpoint based on window width
   * @param {number} windowWidth - Current window width
   * @returns {string|undefined} Current breakpoint name
   */
  getCurrentBreakpoint(windowWidth) {
    return Object.entries(this.breakpoints).sort((_ref, _ref2) => {
      let [, widthA] = _ref;
      let [, widthB] = _ref2;
      return widthB - widthA;
    }).find(_ref3 => {
      let [, width] = _ref3;
      return windowWidth >= width;
    })?.[0];
  }

  /**
   * Initializes the resize handler
   */
  init() {
    window.addEventListener('resize', this.debouncedResize);
    window.addEventListener('load', this.handleResize);

    // If window has already loaded, trigger initial resize
    if (document.readyState === 'complete') {
      this.handleResize();
    }
  }
}

// Usage
export default () => {
  const handler = new ResizeHandler();
  handler.init();
  return handler;
};